export const getDeviceType = (): string => {
    const { userAgent } = window.navigator;
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'Ios';
    }

    return 'Website';
};
